import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserService } from '../../../shared/services/user.service';

export const guaranteeGuard: CanActivateFn = () => {
	const router = inject(Router);
	const { user } = inject(UserService);
	if (!user.hasService('PGNTE')) {
		return router.createUrlTree(['/']);
	}
	return true;
};
